"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { createModal, showModal, escapeHtml, renderAnalyticsTabs, analyticsI18n } from "./shared_modal";
const RESOURCE_ANALYTICS_ENDPOINT = "/api/resource_analytics";
function initResourceAnalytics() {
  document.querySelectorAll("[data-resource-analytics]").forEach((btn) => {
    if (btn.dataset.resourceAnalyticsBound) return;
    btn.dataset.resourceAnalyticsBound = "true";
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const resourceType = btn.dataset.resourceType;
      const resourceId = btn.dataset.resourceId;
      fetchResourceAnalytics(resourceType, resourceId);
    });
  });
}
function fetchResourceAnalytics(resourceType, resourceId) {
  return __async(this, null, function* () {
    var _a;
    const i18n = analyticsI18n();
    const modal = createModal(i18n.title, i18n.loading);
    showModal(modal);
    try {
      const response = yield fetch(RESOURCE_ANALYTICS_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": ((_a = document.querySelector('meta[name="csrf-token"]')) == null ? void 0 : _a.content) || ""
        },
        body: JSON.stringify({
          resource_type: resourceType,
          resource_id: resourceId
        })
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = yield response.json();
      renderAnalyticsTabs(modal, data);
    } catch (err) {
      const content = modal.querySelector(".analytics-modal__content");
      content.innerHTML = `<p class="analytics-modal__error">${escapeHtml(i18n.error)}: ${escapeHtml(err.message)}</p>`;
    }
  });
}
document.addEventListener("DOMContentLoaded", initResourceAnalytics);
document.addEventListener("turbo:load", initResourceAnalytics);
if (document.readyState !== "loading") {
  initResourceAnalytics();
}
